import EditFooterLinksModal from "./components/EditFooterLinksModal";
import ExtensionPage from "./components/ExtensionPage";
import ExtensionsPage from "./components/ExtensionsPage";
import UploadImageButton from "./components/UploadImageButton";

export default {
  "extensions/afrux-theme-base/admin/components/EditFooterLinksModal":
    EditFooterLinksModal,
  "extensions/afrux-theme-base/admin/components/ExtensionPage": ExtensionPage,
  "extensions/afrux-theme-base/admin/components/ExtensionsPage": ExtensionsPage,
  "extensions/afrux-theme-base/admin/components/UploadImageButton":
    UploadImageButton,
};
